import {
  CLEAR_FISCAL_CAPITAL_BALANCE,
  CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS,
  LOAD_FISCAL_CAPITAL_BALANCE,
  LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY,
  LOAD_FISCAL_CAPITAL_BALANCE_KPIS,
  SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS,
  CLEAR_ACCOUNTING_CAPITAL_BALANCE,
  CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
  LOAD_ACCOUNTING_CAPITAL_BALANCE,
  LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY,
  LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS,
  SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
  LOAD_FISCAL_TERMINATION_AUDIT,
  CLEAR_FISCAL_TERMINATION_AUDIT,
  SAVE_FISCAL_TERMINATION_AUDIT_OPTIONS,
  LOAD_ACCOUNTING_TERMINATION_AUDIT,
  CLEAR_ACCOUNTING_TERMINATION_AUDIT,
  SAVE_ACCOUNTING_TERMINATION_AUDIT_OPTIONS
} from '../actions/capitalBalanceActions';

const initialKpis = {
  activeContracts: 0,
  currentMonthFinalBalance: 0,
  termination: {
    total: 0,
    contractCount: 0,
    offendingContracts: [],
    offendingContractCount: 0
  }
};

const initialTerminationAudit = {
  // No limit/offset here on purpose: the backend returns the full,
  // uncapped offender list in one request (real offender counts are
  // tiny against the whole portfolio), and pagination is done
  // client-side in TerminationAuditList so paging never re-triggers a
  // full portfolio schedule recomputation on the backend.
  options: {},
  items: [],
  count: 0,
  tolerance: null
};

const initialState = {
  fiscal: {
    options: { limit: +process.env.REACT_APP_TABLE_SIZE, page: 0 },
    items: [],
    count: 0,
    summary: {
      items: [],
      count: 0
    },
    kpis: initialKpis
  },
  accounting: {
    options: { limit: +process.env.REACT_APP_TABLE_SIZE, page: 0 },
    items: [],
    count: 0,
    summary: {
      items: [],
      count: 0
    },
    kpis: initialKpis
  },
  fiscalTerminationAudit: initialTerminationAudit,
  accountingTerminationAudit: initialTerminationAudit
};

const capitalBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_FISCAL_CAPITAL_BALANCE.success: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          items: action.items,
          count: action.count
        }
      };
    }
    case SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          options: { ...state.fiscal.options, ...action.options }
        }
      };
    }
    case CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          options: initialState.fiscal.options
        }
      };
    }
    case CLEAR_FISCAL_CAPITAL_BALANCE: {
      return {
        ...state,
        fiscal: initialState.fiscal
      };
    }
    case LOAD_ACCOUNTING_CAPITAL_BALANCE.success: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          items: action.items,
          count: action.count
        }
      };
    }
    case SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          options: { ...state.accounting.options, ...action.options }
        }
      };
    }
    case CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          options: initialState.accounting.options
        }
      };
    }
    case CLEAR_ACCOUNTING_CAPITAL_BALANCE: {
      return {
        ...state,
        accounting: initialState.accounting
      };
    }
    case LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY.success: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          summary: {
            items: action.items,
            count: action.count
          }
        }
      };
    }
    case LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY.success: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          summary: {
            items: action.items,
            count: action.count
          }
        }
      };
    }
    case LOAD_FISCAL_CAPITAL_BALANCE_KPIS.success: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          kpis: {
            activeContracts: action.activeContracts,
            currentMonthFinalBalance: action.currentMonthFinalBalance,
            termination: action.termination
          }
        }
      };
    }
    case LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS.success: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          kpis: {
            activeContracts: action.activeContracts,
            currentMonthFinalBalance: action.currentMonthFinalBalance,
            termination: action.termination
          }
        }
      };
    }

    case LOAD_FISCAL_TERMINATION_AUDIT.success: {
      return {
        ...state,
        fiscalTerminationAudit: {
          ...state.fiscalTerminationAudit,
          items: action.items,
          count: action.count,
          tolerance: action.tolerance
        }
      };
    }
    case SAVE_FISCAL_TERMINATION_AUDIT_OPTIONS: {
      return {
        ...state,
        fiscalTerminationAudit: {
          ...state.fiscalTerminationAudit,
          options: {
            ...state.fiscalTerminationAudit.options,
            ...action.options
          }
        }
      };
    }
    case CLEAR_FISCAL_TERMINATION_AUDIT: {
      return {
        ...state,
        fiscalTerminationAudit: initialTerminationAudit
      };
    }
    case LOAD_ACCOUNTING_TERMINATION_AUDIT.success: {
      return {
        ...state,
        accountingTerminationAudit: {
          ...state.accountingTerminationAudit,
          items: action.items,
          count: action.count,
          tolerance: action.tolerance
        }
      };
    }
    case SAVE_ACCOUNTING_TERMINATION_AUDIT_OPTIONS: {
      return {
        ...state,
        accountingTerminationAudit: {
          ...state.accountingTerminationAudit,
          options: {
            ...state.accountingTerminationAudit.options,
            ...action.options
          }
        }
      };
    }
    case CLEAR_ACCOUNTING_TERMINATION_AUDIT: {
      return {
        ...state,
        accountingTerminationAudit: initialTerminationAudit
      };
    }

    default: {
      return state;
    }
  }
};

export default capitalBalanceReducer;
